import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "react-phone-input-2/lib/style.css";
import "./index.css";

import reportWebVitals from "./reportWebVitals";
import App from "./App";
import Payment from "./components/payment-component/payment";
import Product from "./components/product-component/product";
import ApiService from "./services/api.service";

// import Renewal from './components/product-component/product';
import Login from "./components/Pages/login";
import Register from "./components/Pages/register";
import Renewal from "./components/Pages/renewal";
import Transaction from "./components/Pages/transaction";
import ExpressCheckout from "./components/Pages/express-checkout";
import OAuthCallback from "./components/oauth";

//import('https://checkout.limepay.com.au/v2/checkout-v2.1.0.min.js');
//import('https://js.stripe.com/v3/');

const root = ReactDOM.createRoot(document.getElementById("root"));
export let baseUrl =
  "/wp-content/themes/accor-plus/modules/payment-portal/files/webappv2/";
let isLocal = window.location.href.indexOf("localhost") != -1;

if (isLocal) {
  baseUrl =
    "/wp-content/themes/accor-plus/modules/payment-portal/files/webappv2/";
} else {
  baseUrl = window.location.pathname;
}
const callBackUrl =
  "wp-content/themes/accor-plus/modules/payment-portal/files/webappv2/callback";

if (!isLocal && window.location.pathname.indexOf("renewals") != -1) {
  root.render(
    //<React.StrictMode>
    <Router>
      <Routes>
        <Route
          path={baseUrl}
          element={<Renewal baseUrl={baseUrl} isLogged={true} />}
        />
      </Routes>
    </Router>
    //</React.StrictMode>
  );
} else if (
  !isLocal &&
  window.location.pathname.indexOf("express-checkout") != -1
) {
  root.render(
    //<React.StrictMode>
    <Router>
      <Routes>
        <Route
          path={baseUrl}
          element={<ExpressCheckout baseUrl={baseUrl} isLogged={true} />}
        />
      </Routes>
    </Router>
    //</React.StrictMode>
  );
} else {
  root.render(
    //<React.StrictMode>
    <Router>
      <Routes>
        <Route exact path={baseUrl} element={<App baseUrl={baseUrl} />} />
        <Route exact path={baseUrl + "payment"} element={<Payment />} />
        <Route
          exact
          path={baseUrl + "renewals"}
          element={<Renewal baseUrl={baseUrl} isLogged={true} />}
        />
        <Route
          exact
          path={baseUrl + "express-checkout"}
          element={<ExpressCheckout baseUrl={baseUrl} isLogged={true} />}
        />
        <Route exact path={baseUrl + "login"} element={<Login />} />
        <Route exact path={baseUrl + "registration"} element={<Register />} />
        <Route exact path={baseUrl + "transaction"} element={<Transaction />} />
        <Route exact path={callBackUrl} element={<OAuthCallback />} />
      </Routes>
    </Router>
    //</React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
